<div class="layout-topbar shadow-4 top">
  <div class="layout-topbar-left">
    <a class="layout-topbar-logo" routerLink="/">
      <img id="app-logo" src="./../assets/layout/images/logo2x.png" alt="ultima-layout" style="height: 2rem">
    </a>
  </div>
</div>

<div style="background-image: url('{{backGroundImage}}');" class="pages-body flex flex-column cust-height bg-image">
  <div class="align-self-center mt-auto mb-auto" style="width: 350px; margin-top: 20% !important;">
    <div class="pages-panel card flex flex-column">
      <div class="col-12" style="text-align: center">
        <img [src]="logo">
      </div>
      <form (ngSubmit)="onSubmit()" id="form">
        <div class="p-field col-12">
          <span class="p-float-label">
            <input
              (ngModelChange)="hideDialog()"
              pInputText
              [(ngModel)]="identifiant"
              autofocus
              name="identifiant"
              id="identifiant"
              autocomplete="off"
              class="p-inputtext p-component"
              />
              <label for="identifiant">{{'Login.Login' | translate}}</label>
            </span>
        </div>
        <div class="p-field col-12">
          <span class="p-float-label">
            <p-password
              (ngModelChange)="hideDialog()"
              name="password"
              id="password"
              [(ngModel)]="password" [toggleMask]="true" [feedback]="false"
              >
            </p-password>
            <label for="password">{{'Login.Password' | translate}}</label>
          </span>
        </div>
        @if (displayModal) {
          <div class="col-12 error width-100">
            {{ errMessage }}
          </div>
        }
        <div class="col-12">
          <p-button styleClass="width-100" type="submit" label="{{'Login.Connect' | translate}}" icon="pi pi-user"></p-button>
        </div>
        @if (displayAzure) {
          <div class="col-12">
            @if (!loginDisplay) {
              <p-button styleClass="width-100" type="button"  label="{{'Login.Azure' | translate}}" icon="pi pi-user" (click)="clickAzure()"></p-button>
            }
          </div>              
        }
      </form>
    </div>
  </div>
</div>

